import React from 'react';
import {
  CallToAction,
  Heading,
  ModalBody,
  ModalFooter,
} from '@americanexpress/dls-react';
import {
  FHROverlayIcon,
  THCOverlayIcon,
  sanitize,
} from '@americanexpress/consumer-travel-base';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Progress from '../Steps/Progress';
import { useDataFromOneCMS } from '../../fetchye/useDataFromOneCMS';

const ModalContent = ({ onCallToActionClick }) => {
  const { formatMessage } = useIntl();

  const currentDate = new Date();
  const isTodaysDateCloseToExpiry = currentDate.getMonth() >= 10;

  const heading = useDataFromOneCMS(
    `hotelCreditModal.${isTodaysDateCloseToExpiry ? 'headingCloseToExpiry' : 'heading'}`
  );
  const body = useDataFromOneCMS(
    `hotelCreditModal.${isTodaysDateCloseToExpiry ? 'bodyCloseToExpiry' : 'body'}`
  );
  const stepsHeading = useDataFromOneCMS('howToSection.heading');
  const buttonText = useDataFromOneCMS('hotelCreditModal.buttonText');

  return (
    <>
      <ModalBody>
        <div className="text-align-center pad-2">
          <h2 className="heading-5 pad-1-b dls-deep-blue">{heading}</h2>
          <p
            className="body-1"
            dangerouslySetInnerHTML={{ __html: sanitize(body, { html: true }) }}
          />
        </div>
        <div className="dls-bright-blue-bg pad-2">
          <div className="row flex flex-justify-center pad-1-b">
            <FHROverlayIcon className="pad-1-r" />
            <THCOverlayIcon />
          </div>
          <div className="pad-0-tb-sm-down flex flex-column flex-justify-center flex-align-items-center">
            <div className="text-align-center pad-1-b-sm-down color-graphic-brand-logo-blue-box-text pad-1-b pad-2-t-sm-down">
              <Heading level={2} variant="sans-small-regular">
                {' '}{stepsHeading}{' '}
              </Heading>
            </div>
            <Progress isOverlay={true} />
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <CallToAction
          href={formatMessage({ id: 'hotelCreditUrl' })}
          reactlytics={{ element: 'linkToLandingPage' }}
          onClick={onCallToActionClick}
          variant="primary"
        >
          {buttonText}
        </CallToAction>
      </ModalFooter>
    </>
  );
};

ModalContent.propTypes = {
  onCallToActionClick: PropTypes.func.isRequired,
};

export default ModalContent;
